// services/Google/useGoogleLoginHandler.ts
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { AuthenticationActionCreator } from '../../actions/AuthenticationActionCreator';
import CookieStorageAPI from 'core/storage/CookieStorageAPI';
import { addMinutes } from 'date-fns';
import { IRequestDataFailedAction } from 'models/state';
import { isError } from 'models/core/error/IError';
import Alert from 'core/Alert';

export function useGoogleLoginHandler() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const handleLoginFinished = useCallback(
    async (response: any) => {
      const token = response?.access_token;

      if (!token) {
        Alert.alert('Anmeldung fehlgeschlagen', 'Google Token konnte nicht abgerufen werden.');
        return;
      }

      try {
        // ✅ Step 1: Get user profile from Google using the token
        const userInfo = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }).then((res) => res.json());

        const { email, name, sub: googleId } = userInfo;

        // ✅ Step 2: Send token + user info to backend
        const loginResp = await dispatch(
          AuthenticationActionCreator.loginGoogleUser({
            googleToken: token,
            data: userInfo
          })
        ) as IRequestDataFailedAction;

        if (isError(loginResp)) {
          Alert.alert('Login fehlgeschlagen', 'Bitte versuche es erneut.');
          return;
        }

        // ✅ Step 3: Continue normal login flow
        CookieStorageAPI.setItem('loggedIN', 'true', { expires: addMinutes(new Date(), 5) });

        const searchParams = new URLSearchParams(location.search);
        const redirect = searchParams.get('redirect') || '/explorer';
        history.replace(redirect);
      } catch (error) {
        Alert.alert('Fehler', 'Google-Nutzerinformationen konnten nicht abgerufen werden.');
      }
    },
    [dispatch, history, location]
  );

  return handleLoginFinished;
}

export default useGoogleLoginHandler;
